export function camelToSnake(str: string) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function isNonNull<T>(v: T | null | undefined): v is NonNullable<T> {
  return v != null;
}